import React, { useEffect, useState } from "react";
import { PAGINATION_PAGE_SIZE_OPTIONS } from "../../config/pagination";
import { displayDate } from "../../utils/dateUtils";
import {
  formatRoleOptionLabel,
  formatRoleScopeBadge,
  roleOptionValue,
  parseRoleOptionValue,
} from "../../utils/roleDisplay";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
  Grid,
  Chip,
  Avatar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  FormHelperText,
  Select,
  MenuItem,
  InputAdornment,
  Tab,
  Tabs,
  Stepper,
  Step,
  StepLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  LinearProgress,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import {
  Add,
  Edit,
  Delete,
  Visibility,
  Download,
  Upload,
  Lock,
  LockOpen,
  People,
  School,
  Person,
  AdminPanelSettings,
  Close,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import DataTable from "../../components/data-display/DataTable";
import StatsCard from "../../components/data-display/StatsCard";
import StatusChip from "../../components/data-display/StatusChip";
import SearchBar from "../../components/navigation/SearchBar";
import FilterTabs from "../../components/navigation/FilterTabs";
import ActionButtons from "../../components/actions/ActionButtons";
import PermissionGate from "../../components/common/PermissionGate";
import FormDialog from "../../components/forms/FormDialog";
import FormTextField from "../../components/forms/FormTextField";
import FormSelect from "../../components/forms/FormSelect";
import ImportDialog from "../../components/import-export/ImportDialog";
import DataImportWizard from "../../components/common/DataImportWizard";
import { resolveUserDisplayName } from "../../utils/userDisplay";
import { usePermissions } from "../../hooks/usePermissions";
import { revealUserPii } from "../../services/piiService";
import { PII_PERMISSIONS } from "../../utils/piiPermissions";
import userService from "../../services/userService";
import importService from "../../services/importService";
import rbacService from "../../services/rbacService";
import api from "../../services/api";
import { getAvatarInitial } from "../../utils/avatarUtils";
import HODTeachers from "../hod/Teachers";
import TeacherStudents from "../teacher/Students";

const TAB_ROLES = ["All", "Student", "Teacher", "HOD", "Admin"];
const INITIAL_FORM_DATA = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  role: "",
  department: "",
  departmentId: "",
};

const Users = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [roleSelectDialogOpen, setRoleSelectDialogOpen] = useState(false);
  const [selectedCreateRole, setSelectedCreateRole] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [viewingUser, setViewingUser] = useState(null);
  const [teacherPopupState, setTeacherPopupState] = useState({
    open: false,
    role: "teacher",
    mode: "create",
    editData: null,
    prefillLoading: false,
  });
  const [studentPopupState, setStudentPopupState] = useState({
    open: false,
    mode: "create",
    editData: null,
    prefillLoading: false,
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [revealingUserPii, setRevealingUserPii] = useState(false);
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  // ---- PII reveal (unmask) ----
  const { hasPermission } = usePermissions();

  // Departments state
  const [departments, setDepartments] = useState([]);
  const [departmentsLoading, setDepartmentsLoading] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(false);

  // Get current user role from localStorage
  const [currentUserRole, setCurrentUserRole] = useState(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return user?.role?.toLowerCase() || localStorage.getItem('userRole')?.toLowerCase() || 'admin';
    } catch {
      return localStorage.getItem('userRole')?.toLowerCase() || 'admin';
    }
  });

  // Import states
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [importWizardOpen, setImportWizardOpen] = useState(false);
  const [previewData, setPreviewData] = useState([]);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countsLoading, setCountsLoading] = useState(false);
  const [refreshingList, setRefreshingList] = useState(false);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [totalCount, setTotalCount] = useState(0);
  const [userCounts, setUserCounts] = useState({
    students: 0,
    teachers: 0,
    hod: 0,
    admins: 0,
    totalUsers: 0,
  });
  const [importHistory] = useState([
    {
      id: 1,
      fileName: "users_batch_1.xlsx",
      uploadedAt: "2024-01-15 10:30",
      totalRows: 50,
      success: 48,
      failed: 2,
      errors: [
        {
          row: 12,
          field: "email",
          value: "invalid-email",
          error: "Invalid email format",
        },
        {
          row: 35,
          field: "phone",
          value: "123",
          error: "Phone must be 10 digits",
        },
      ],
    },
    {
      id: 2,
      fileName: "new_students.csv",
      uploadedAt: "2024-01-10 14:45",
      totalRows: 100,
      success: 100,
      failed: 0,
      errors: [],
    },
  ]);


  const handleDeleteUser = async () => {
    if (!userToDelete) return;
    setDeleting(true);
    try {
      await userService.deleteUser(userToDelete.id);
      // Refresh the users list
      const roleFilter = activeTab === 0 ? undefined : TAB_ROLES[activeTab];
      const params = {
        search: searchQuery || undefined,
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        sort: "createdAt",
        order: "desc",
        ...(roleFilter && roleFilter !== "All"
          ? { role: roleFilter.toLowerCase() }
          : {}),
      };
      const { data } = await userService.getAdminUsers(params);
      const list = data?.data?.docs || data?.data?.data || data?.data?.users || data?.data || [];
      setUsers(
        list.map((user, index) => {
          const normalizedName =
            resolveUserDisplayName(user, { fallback: `User ${index + 1}` }) ||
            `User ${index + 1}`;

          return {
            id:
              user.id ??
              user._id ??
              user.userId ??
              user.uuid ??
              `${user.email || "user"}-${index}`,
            name: normalizedName,
            email: user.email || user.username || "-",
            phone:
              user.phone ||
              user.mobile ||
              user.contactNumber ||
              user.phoneNumber ||
              "-",
            role:
              formatRoleLabel(
                user.role || user.userRole || user.roleName || user.accessRole
              ) || "-",
            // Preserve the raw role slug and departmentId so the edit dialog can preselect
            // its Role/Department dropdowns (the display `role`/`department` are prettified
            // label/name strings that don't match the Select option values).
            roleSlug: user.role || user.userRole || user.roleName || user.accessRole || "",
            departmentId:
              user.departmentId ??
              user.department?.id ??
              null,
            department:
              user.department?.name ||
              user.departmentName ||
              user.department ||
              "-",
            status: formatStatus(user.status ?? user.accountStatus),
            createdAt:
              formatDate(user.createdAt || user.joinedAt || user.createdDate),
            raw: user,
          };
        })
      );
      setTotalCount(data?.data?.total || data?.data?.totalCount || list.length);
      setDeleteDialogOpen(false);
      setUserToDelete(null);
      await refreshUsersAndCounts();
      setSnackbar({
        open: true,
        message: "User deleted successfully!",
        severity: "success"
      });
    } catch (error) {
      console.error("Failed to delete user:", error);
      setSnackbar({
        open: true,
        message: "Failed to delete user",
        severity: "error"
      });
    } finally {
      setDeleting(false);
    }
  };

  const handleCreateUser = async () => {
    const errors = validateForm(formData);
    if (Object.keys(errors).length > 0) {
      setFormErrors({ ...errors, submit: "Please fill all required fields" });
      return;
    }
    setFormErrors({});
    setSubmitting(true);
    try {
      const resolvedRole = parseRoleOptionValue(formData.role, availableRoles);
      const roleSlug = String(resolvedRole?.slug || resolvedRole?.role || formData.role || "").trim();
      const selectedDept = departments.find(
        (d) =>
          String(d.id) === String(formData.departmentId) ||
          String(d._id) === String(formData.departmentId) ||
          (d.name || d) === formData.department
      );
      const isDeptOptional = isRoleDepartmentOptional(roleSlug, availableRoles);
      const payload = {
        ...formData,
        role: roleSlug,
        departmentId: formData.departmentId
          ? Number(formData.departmentId)
          : selectedDept?.id ?? selectedDept?._id ?? (isDeptOptional ? null : undefined),
        department: selectedDept?.name || formData.department || (isDeptOptional ? null : undefined),
      };
      if (editingUser) {
        if (!payload.email || String(payload.email).trim() === "") {
          delete payload.email;
        }
        if (!payload.phoneNumber || String(payload.phoneNumber).trim() === "") {
          delete payload.phoneNumber;
        }
        if (isDeptOptional && !formData.departmentId) {
          payload.departmentId = null;
          payload.department = null;
        }
        await userService.updateUser(editingUser.id, payload);
      } else {
        await userService.createUser(payload);
      }

      setCreateDialogOpen(false);
      setEditingUser(null);
      setFormData(INITIAL_FORM_DATA);
      setSnackbar({
        open: true,
        message: editingUser ? "User updated successfully!" : "User created successfully! Refreshing list…",
        severity: "success",
      });
      await refreshUsersAndCounts();
      setSnackbar({
        open: true,
        message: editingUser ? "User updated successfully!" : "User created successfully!",
        severity: "success",
      });
    } catch (error) {
      console.error("Failed to save user:", error);
      const apiMessage = error?.response?.data?.message;
      const is409 = error?.response?.status === 409;
      setSnackbar({
        open: true,
        message: is409 && apiMessage ? apiMessage : `Failed to ${editingUser ? 'update' : 'create'} user`,
        severity: "error"
      });
    } finally {
      setSubmitting(false);
    }
  };

  // Replace existing handleImport to refresh list immediately after import completes
  const handleImport = async (file, data) => {
    // If you have a real import service call, call it here and then refresh.
    // This simulated implementation resolves and then forces an immediate refresh.
    return new Promise((resolve) => {
      setTimeout(async () => {
        const result = {
          totalRows: Array.isArray(data) ? data.length : 0,
          success: (Array.isArray(data) ? data.length : 0) - 2,
          failed: 2,
          errors: [
            { row: 12, field: "email", value: "invalid", error: "Invalid email" },
            { row: 35, field: "phone", value: "123", error: "Invalid phone" },
          ],
        };

        // Immediately refresh list and counts so imported rows show up
        try {
          await refreshUsersAndCounts();
        } catch (err) {
          console.error("Error refreshing users after import:", err);
        }

        resolve(result);
      }, 2000);
    });
  };

  const previewColumns = [
    { field: "name", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Phone", width: 130 },
    { field: "role", headerName: "Role", width: 100 },
    { field: "department", headerName: "Department", width: 260 },
  ];

  const validateRow = (row) => {
    if (!row.email || !row.email.includes("@")) {
      return { valid: false, error: "Invalid email format" };
    }
    if (!row.phone || row.phone.length < 10) {
      return { valid: false, error: "Invalid phone number" };
    }
    return { valid: true };
  };

  // Import report handlers - can be implemented if needed
  // const handleViewImportReport = (report) => {
  //   setSelectedImportReport(report);
  //   setImportResultsDialogOpen(true);
  // };

  // const handleDownloadReport = (report) => {
  //   console.log("Downloading report:", report);
  // };

  const formatRoleLabel = (role = "") => {
    const lower = role.toLowerCase();
    if (!role) return "";
    if (lower === "hod") return "HOD";
    if (lower === "superadmin") return "SuperAdmin";
    return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
  };

  const isRoleDepartmentOptional = (roleStr, rolesList = availableRoles) => {
    const resolved = parseRoleOptionValue(roleStr, rolesList);
    const slug = String(resolved?.slug || resolved?.role || roleStr || "").trim().toLowerCase();
    return ["admin", "superadmin", "super admin", "institute"].includes(slug);
  };

  const matchRole = (userRole, role) => {
    if (!role || role === "All") return true;

    // Define role groupings for better categorization in RBAC system
    const roleGroups = {
      Student: ['student'],
      Teacher: ['teacher', 'lecturer', 'professor', 'assistant professor', 'associate professor', 'visiting faculty', 'adjunct faculty', 'instructor'],
      HOD: ['hod', 'head of department', 'department head'],
      Admin: ['admin', 'administrator', 'superadmin', 'superAdmin']
    };

    const targetRoles = roleGroups[role];
    if (targetRoles) {
      return targetRoles.some(targetRole =>
        formatRoleLabel(userRole).toLowerCase().includes(targetRole.toLowerCase()) ||
        targetRole.toLowerCase().includes(formatRoleLabel(userRole).toLowerCase())
      );
    }

    // Fallback to exact match for any other roles
    return formatRoleLabel(userRole) === formatRoleLabel(role);
  };

  const formatStatus = (value) => {
    if (typeof value === "string") return value;
    if (typeof value === "boolean") return value ? "Active" : "Inactive";
    if (typeof value === "object" && value !== null) {
      return (
        value.status ||
        value.label ||
        value.name ||
        value.state ||
        "Unknown"
      );
    }
    if (value === undefined || value === null) return "Unknown";
    return String(value);
  };

  const formatDate = (value) => {
    if (!value) return "-";
    return displayDate(value, "-");
  };

  const roleColors = {
    Student: "info",
    Teacher: "success",
    HOD: "secondary",
    Admin: "warning",
    SuperAdmin: "error",
  };

  const columns = [
    {
      field: "name",
      headerName: "User",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Avatar sx={{ width: 36, height: 36 }}>
            {getAvatarInitial(params.row)}
          </Avatar>
          <Box>
            <Typography variant="body2" fontWeight={500}>
              {params.row.name || "Unknown User"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {params.row.email}
            </Typography>
          </Box>
        </Box>
      ),
    },
    { field: "phone", headerName: "Phone", width: 130 },
    {
      field: "role",
      headerName: "Role",
      width: 100,
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          color={roleColors[formatRoleLabel(params.value)] || "default"}
        />
      ),
    },
    {
      field: "department",
      headerName: "Department",
      width: 260,
      renderCell: (params) => {
        const dept = params.value;
        if (dept && dept !== "-") return dept;
        const role = params.row?.role || params.row?.raw?.role || "";
        if (isRoleDepartmentOptional(role, availableRoles)) {
          return (
            <Typography variant="caption" color="text.secondary" sx={{ fontStyle: "italic" }}>
              All Departments (Institute-wide)
            </Typography>
          );
        }
        return "-";
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      renderCell: (params) => {
        const v=params.row?.raw?.status??params.value;
        const s=typeof v==="boolean"?v:(typeof v==="string"?v.toLowerCase():"");
        const isActive=typeof v==="boolean"?v:!(s.includes("inact")||s==="false"||s==="0");
        return <StatusChip status={isActive?"active":"inactive"} />;
      },
    },
    { field: "createdAt", headerName: "Created", width: 110 },
  ];

  // Fetch only stats (totalUsers, students, teachers, hod) - no role filter so we get global counts
  const fetchUserCounts = async ({ silent = false } = {}) => {
    if (!silent) setCountsLoading(true);
    try {
      const { data } = await userService.getAdminUsers({
        page: 1,
        limit: 1,
        sort: "createdAt",
        order: "desc",
      });
      const serverCounts = data?.data?.counts;
      if (serverCounts) {
        setUserCounts({
          students: serverCounts.students || 0,
          teachers: serverCounts.teachers || 0,
          hod: serverCounts.hod || 0,
          admins: serverCounts.admins || serverCounts.admin || 0,
          totalUsers: serverCounts.totalUsers || 0,
        });
      }
    } catch (err) {
      console.error("Failed to fetch user counts", err);
    } finally {
      if (!silent) setCountsLoading(false);
    }
  };

  const refreshUsersAndCounts = async () => {
    setRefreshingList(true);
    setLoading(true);
    setCountsLoading(true);
    try {
      await Promise.all([fetchUsers({ silent: true }), fetchUserCounts({ silent: true })]);
    } finally {
      setLoading(false);
      setCountsLoading(false);
      setRefreshingList(false);
    }
  };

  const fetchUsers = async ({ silent = false } = {}) => {
    if (!silent) setLoading(true);
    try {
      const roleFilter = activeTab === 0 ? undefined : TAB_ROLES[activeTab];
      const params = {
        search: searchQuery || undefined,
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        sort: "createdAt",
        order: "desc",
        ...(roleFilter && roleFilter !== "All"
          ? { role: roleFilter.toLowerCase() }
          : {}),
      };

      const { data } = await userService.getAdminUsers(params);
      const list =
        data?.data?.docs ||
        data?.data?.data ||
        data?.data?.users ||
        data?.data ||
        data?.users ||
        [];

      const paginationTotal = Number(data?.data?.pagination?.totalItems ?? data?.data?.pagination?.total);
      const total =
        Number.isFinite(paginationTotal) && paginationTotal >= 0
          ? paginationTotal
          : data?.data?.totalDocs ??
            data?.data?.total ??
            data?.data?.count ??
            data?.totalDocs ??
            data?.total ??
            data?.count ??
            data?.meta?.total ??
            data?.meta?.totalDocs ??
            list.length;

      // Capture server-side counts (totals across ALL pages, not just current page)
      const serverCounts = data?.data?.counts;
      if (serverCounts) {
        setUserCounts({
          students: serverCounts.students || 0,
          teachers: serverCounts.teachers || 0,
          hod: serverCounts.hod || 0,
          admins: serverCounts.admins || serverCounts.admin || 0,
          totalUsers: serverCounts.totalUsers || 0,
        });
      }

      setUsers(
        list.map((user, index) => {
          const normalizedName =
            resolveUserDisplayName(user, { fallback: `User ${index + 1}` }) ||
            `User ${index + 1}`;

          return {
            id:
              user.id ??
              user._id ??
              user.userId ??
              user.uuid ??
              `${user.email || "user"}-${index}`,
            name: normalizedName,
            email: user.email || user.username || "-",
            phone:
              user.phone ||
              user.mobile ||
              user.contactNumber ||
              user.phoneNumber ||
              "-",
            role:
              formatRoleLabel(
                user.role || user.userRole || user.roleName || user.accessRole
              ) || "-",
            // Preserve the raw role slug and departmentId so the edit dialog can preselect
            // its Role/Department dropdowns (the display `role`/`department` are prettified
            // label/name strings that don't match the Select option values).
            roleSlug: user.role || user.userRole || user.roleName || user.accessRole || "",
            departmentId:
              user.departmentId ??
              user.department?.id ??
              null,
            department:
              user.department?.name ||
              user.departmentName ||
              user.department ||
              "-",
            status: formatStatus(user.status ?? user.accountStatus),
            createdAt:
              formatDate(user.createdAt || user.joinedAt || user.createdDate),
            raw: user,
          };
        })
      );
      // Use pagination total for the current query (tab/role filter is already applied server-side).
      setTotalCount(Number(total) || list.length);
    } catch (error) {
      console.error("Failed to fetch admin users", error);
      setUsers([]);
      setTotalCount(0);
    } finally {
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [activeTab, searchQuery, paginationModel.page, paginationModel.pageSize]);

  // Fetch departments
  useEffect(() => {
    let isMounted = true;

    const fetchDepartments = async () => {
      setDepartmentsLoading(true);
      try {
        const response = await userService.getDepartmentNames();
        const departmentList = response.data?.data || response.data || [];

        if (isMounted) {
          setDepartments(departmentList);
        }
      } catch (error) {
        console.error("Failed to fetch departments:", error);
        if (isMounted) {
          setDepartments([]);
        }
      } finally {
        if (isMounted) {
          setDepartmentsLoading(false);
        }
      }
    };

    fetchDepartments();

    return () => {
      isMounted = false;
    };
  }, []);

  // Fetch available roles from permission API
  useEffect(() => {
    let isMounted = true;

    const fetchRoles = async () => {
      setRolesLoading(true);
      try {
        const response = await rbacService.getAllRolesWithStats();
        const rolesPayload =
          response?.data?.data?.roles ||
          response?.data?.data ||
          response?.data?.roles ||
          response?.data ||
          [];

        const parsedRoles = (Array.isArray(rolesPayload) ? rolesPayload : [])
          .filter((roleItem) => roleItem && typeof roleItem === "object")
          .filter((roleItem) => {
            const slug = String(roleItem.slug || roleItem.role || "").toLowerCase();
            return slug !== "superadmin" && slug !== "super admin";
          });

        if (isMounted) {
          setAvailableRoles(parsedRoles);
        }
      } catch (error) {
        console.error("Failed to fetch roles:", error);
        if (isMounted) {
          setAvailableRoles([]);
        }
      } finally {
        if (isMounted) {
          setRolesLoading(false);
        }
      }
    };

    fetchRoles();

    return () => {
      isMounted = false;
    };
  }, []);

  // Server already applies search + role tab filter; do not re-filter paginated rows client-side.
  const displayUsers = users;
  const rowCount = Number(totalCount) || displayUsers.length;

  const handlePaginationChange = (model) => {
    setPaginationModel(model);
  };

  const resetToFirstPage = () =>
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    resetToFirstPage();
  };

  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
    resetToFirstPage();
  };

  const validateForm = (data) => {
    const errors = {};

    if (!data.firstName || !data.firstName.trim()) {
      errors.firstName = "Please fill this field";
    } else if (/\d/.test(data.firstName)) {
      errors.firstName = "Numbers are not allowed";
    } else if (data.firstName.trim().length < 3) {
      errors.firstName = "First name must be 3–50 characters";
    } else if (data.firstName.trim().length > 50) {
      errors.firstName = "First name must be 3–50 characters";
    }

    if (!data.lastName || !data.lastName.trim()) {
      errors.lastName = "Please fill this field";
    } else if (/\d/.test(data.lastName)) {
      errors.lastName = "Numbers are not allowed";
    } else if (data.lastName.trim().length < 3) {
      errors.lastName = "Last name must be 3–50 characters";
    } else if (data.lastName.trim().length > 50) {
      errors.lastName = "Last name must be 3–50 characters";
    }

    // Email validation: on edit, blank email means unchanged (not revealed or not modified)
    if (!data.email || !data.email.trim()) {
      if (!editingUser) {
        errors.email = "Please fill this field";
      }
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = "Invalid email format";
    }

    // Phone validation: on edit, blank phone means unchanged (not revealed or not modified)
    if (!data.phoneNumber) {
      if (!editingUser) {
        errors.phoneNumber = "Please fill this field";
      }
    } else {
      const digitsOnly = String(data.phoneNumber).replace(/\D/g, "");
      if (digitsOnly.length > 0 && digitsOnly.length < 10) {
        errors.phoneNumber = "Invalid phone number";
      } else if (!editingUser && digitsOnly.length < 10) {
        errors.phoneNumber = "Invalid phone number";
      }
    }

    if (!data.role || !data.role.trim()) {
      errors.role = "Please fill this field";
    }

    const deptOptional = isRoleDepartmentOptional(data.role, availableRoles);
    if (!deptOptional && !data.departmentId && !(data.department || "").trim()) {
      errors.department = "Please fill this field";
    }

    return errors;
  };

  const resetForm = () => {
    setFormData(INITIAL_FORM_DATA);
    setFormErrors({});
    setEditingUser(null);
  };

  const handleExport = async () => {
    try {
      const response = await importService.exportUsersToCSV({ search: searchQuery });
      const csvData = response.data?.csvData || response.data?.data?.csvData;
      if (csvData) {
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = response.data.fileName || 'users_export.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Export failed:', error);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getCurrentInstituteId = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      return user?.instituteId || null;
    } catch {
      return null;
    }
  };

  const fetchTeacherPrefillData = async (row) => {
    const instituteId = getCurrentInstituteId();
    const role = String(row?.role || "").trim().toLowerCase();
    const params = {
      search: row?.email || row?.name || "",
      page: 1,
      limit: 100,
      sort: "firstName",
      order: "DESC",
      role: role === "hod" ? "hod" : "teacher",
      ...(instituteId ? { instituteId } : {}),
    };
    const response = await api.get("/institute/get-all-teachers", { params });
    const list =
      response?.data?.data?.teachers ||
      response?.data?.data?.rows ||
      response?.data?.data?.items ||
      response?.data?.data ||
      response?.data?.teachers ||
      response?.data?.rows ||
      response?.data?.items ||
      [];
    const arr = Array.isArray(list) ? list : [];
    const raw = row?.raw || {};
    const rowId = String(raw.teacherId || raw.id || row.id || "");
    return (
      arr.find((t) => {
        const tId = String(t?.teacherId || t?.id || "");
        const tEmail = String(t?.email || "").toLowerCase();
        const rowEmail = String(raw?.email || row?.email || "").toLowerCase();
        return (rowId && tId && tId === rowId) || (rowEmail && tEmail === rowEmail);
      }) || raw
    );
  };

  const fetchStudentPrefillData = async (row) => {
    const instituteId = getCurrentInstituteId();
    const params = {
      search: row?.email || row?.name || "",
      page: 1,
      limit: 100,
      sort: "createdAt",
      order: "DESC",
      ...(instituteId ? { instituteId } : {}),
    };
    const response = await api.get("/institute/get-all-institutes-students", { params });
    const list =
      response?.data?.data?.students ||
      response?.data?.data?.rows ||
      response?.data?.data?.items ||
      response?.data?.data ||
      response?.data?.students ||
      response?.data?.rows ||
      response?.data?.items ||
      [];
    const arr = Array.isArray(list) ? list : [];
    const raw = row?.raw || {};
    const rowId = String(raw.studentId || raw.id || row.id || "");
    return (
      arr.find((s) => {
        const sId = String(s?.studentId || s?.id || "");
        const sEmail = String(s?.email || "").toLowerCase();
        const rowEmail = String(raw?.email || row?.email || "").toLowerCase();
        return (rowId && sId && sId === rowId) || (rowEmail && sEmail === rowEmail);
      }) || raw
    );
  };

  const buildTeacherEditData = (raw, row) => ({
    id: raw.teacherId || raw.id || row.id,
    teacherId: raw.teacherId || raw.id || row.id,
    firstName: raw.firstName || row.firstName || row.name?.split(" ")[0] || "",
    lastName:
      raw.lastName || row.lastName || row.name?.split(" ").slice(1).join(" ") || "",
    email: raw.email || row.email || "",
    phone:
      raw.phone || raw.phoneNumber || row.phoneNumber || row.phone || "",
    phoneNumber:
      raw.phoneNumber || raw.phone || row.phoneNumber || row.phone || "",
    gender: raw.gender || "",
    departmentId:
      raw.departmentId || raw.department?._id || raw.department?.id || "",
    qualification: raw.qualification || "",
    experienceYears: raw.experienceYears || "",
    designation: raw.designation || "",
    salary: raw.salary || "",
    joiningDate: raw.joiningDate || "",
    dob: raw.dob || "",
    street: raw.street || "",
    city: raw.city || "",
    state: raw.state || "",
    country: raw.country || "",
    pinCode: raw.pinCode || "",
  });

  const buildStudentEditData = (raw, row) => ({
    id: raw.studentId || raw.id || row.id,
    name:
      raw.fullName ||
      raw.name ||
      [raw.firstName, raw.lastName].filter(Boolean).join(" ") ||
      row.name ||
      "",
    email: raw.email || row.email || "",
    phone:
      raw.phone || raw.phoneNumber || row.phoneNumber || row.phone || "",
    classId:
      raw.classId ||
      raw.class_id ||
      raw.class?.id ||
      raw.class?._id ||
      raw.classInfo?.id ||
      raw.classInfo?._id ||
      row.classId ||
      "",
  });

  const normalizeUserRole = (role) => String(role || "").trim().toLowerCase();

  const isStudentUserRole = (role) => normalizeUserRole(role) === "student";

  const isTeacherUserRole = (role) => {
    const r = normalizeUserRole(role);
    return ["teacher", "hod", "lecturer", "professor", "instructor", "head of department", "department head"].includes(r);
  };

  // A value is considered masked when the backend returns a "***"-style marker.
  const looksMasked = (v) => typeof v === "string" && v.includes("***");

  // Classify a row → which reveal endpoint + record id + required permission.
  //
  // IMPORTANT: the `/users/all-users` list payload keys EVERY row (student,
  // teacher, HOD, institute, admin) by the USER id (`User.id`) — it does NOT
  // carry the Student/Teacher record primary key (there is no `studentId` /
  // `teacherId` on the row). The student/teacher reveal endpoints resolve by
  // `Student.id` / `Teacher.id`, so sending them a user id returned 404
  // "Student not found".
  //
  // Since this screen only ever needs email/phone/dob — exactly what the
  // user-level reveal returns — route ALL rows through `revealUserPii(User.id)`,
  // the same pattern the sibling super-admin "All Users" screen
  // (pages/superadmin/AllUsersManagement.js) already uses. `user.pii.reveal` is
  // granted to institute / admin / superAdmin (the roles that use this screen).
  const resolveRevealTarget = (row) => {
    const userId = row?.raw?.id || row?.raw?.userId || row?.id;
    if (userId) {
      return {
        endpoint: revealUserPii,
        id: userId,
        permission: PII_PERMISSIONS.USER_REVEAL,
      };
    }
    return null;
  };

  const canRevealRow = (row) => {
    const t = resolveRevealTarget(row);
    return !!t && hasPermission(t.permission);
  };

  const rowHasMaskedPii = (row) =>
    looksMasked(row?.email) ||
    looksMasked(row?.phone) ||
    looksMasked(row?.phoneNumber);

  // Reveal PII for a row and merge ONLY email/phone into the target local state.
  // applyTo === "view" → detail dialog (viewingUser); "edit" → inline form (formData).
  // Failures keep values masked and surface a toast; never crash.
  const handleRevealUserPii = async (row, applyTo) => {
    const target = resolveRevealTarget(row);
    if (!target || !target.id) return;
    setRevealingUserPii(true);
    try {
      const res = await target.endpoint(target.id);
      const real = res?.data?.data || {};
      if (applyTo === "view") {
        setViewingUser((prev) =>
          prev
            ? {
                ...prev,
                email: real.email ?? prev.email,
                phone: real.phoneNumber ?? prev.phone,
                phoneNumber: real.phoneNumber ?? prev.phoneNumber,
              }
            : prev
        );
      } else if (applyTo === "edit") {
        setFormData((prev) => ({
          ...prev,
          email: real.email ?? prev.email,
          phoneNumber: real.phoneNumber ?? prev.phoneNumber,
        }));
        setEditingUser((prev) =>
          prev
            ? {
                ...prev,
                email: real.email ?? prev.email,
                phone: real.phoneNumber ?? prev.phone,
                phoneNumber: real.phoneNumber ?? prev.phoneNumber,
              }
            : prev
        );
        setFormErrors((prev) => ({
          ...prev,
          email: undefined,
          phoneNumber: undefined,
        }));
      }
    } catch (e) {
      setSnackbar({
        open: true,
        message:
          e?.response?.data?.message || "Could not reveal personal information",
        severity: "error",
      });
    } finally {
      setRevealingUserPii(false);
    }
  };

  const openStudentDedicatedForm = async (mode, row = null) => {
    if (mode === "edit" && row) {
      setStudentPopupState({ open: true, mode: "edit", editData: null, prefillLoading: true });
      try {
        const raw = await fetchStudentPrefillData(row);
        setStudentPopupState({
          open: true,
          mode: "edit",
          editData: buildStudentEditData(raw, row),
          prefillLoading: false,
        });
      } catch (error) {
        console.error("Failed to load student for edit:", error);
        setStudentPopupState({ open: false, mode: "create", editData: null, prefillLoading: false });
        setSnackbar({ open: true, message: "Failed to load student details", severity: "error" });
      }
      return;
    }
    setStudentPopupState({ open: true, mode: "create", editData: null, prefillLoading: false });
  };

  const openTeacherDedicatedForm = async (mode, row = null, role = "teacher") => {
    const teacherRole = normalizeUserRole(role) === "hod" ? "hod" : "teacher";
    if (mode === "edit" && row) {
      setTeacherPopupState({
        open: true,
        role: teacherRole,
        mode: "edit",
        editData: null,
        prefillLoading: true,
      });
      try {
        const raw = await fetchTeacherPrefillData(row);
        setTeacherPopupState({
          open: true,
          role: teacherRole,
          mode: "edit",
          editData: buildTeacherEditData(raw, row),
          prefillLoading: false,
        });
      } catch (error) {
        console.error("Failed to load teacher for edit:", error);
        setTeacherPopupState({
          open: false,
          role: "teacher",
          mode: "create",
          editData: null,
          prefillLoading: false,
        });
        setSnackbar({ open: true, message: "Failed to load teacher details", severity: "error" });
      }
      return;
    }
    setTeacherPopupState({
      open: true,
      role: teacherRole,
      mode: "create",
      editData: null,
      prefillLoading: false,
    });
  };

  const openUserEditFlow = async (row) => {
    const role = row?.role || "";
    if (isStudentUserRole(role)) {
      await openStudentDedicatedForm("edit", row);
      return;
    }
    if (isTeacherUserRole(role)) {
      await openTeacherDedicatedForm("edit", row, role);
      return;
    }
    setEditingUser(row);
    setFormErrors({});

    // Do NOT seed masked PII into editable fields — saving them would overwrite the real
    // email/phone with the "***" mask. Leave masked values blank; the reveal control (for
    // student/teacher rows) can populate the real values, and the update endpoint ignores
    // blank email/phone as "unchanged".
    const rawEmail = row.email ?? row.raw?.email ?? "";
    const rawPhone = row.phoneNumber ?? row.phone ?? row.raw?.phoneNumber ?? "";
    const safeEmail = looksMasked(rawEmail) ? "" : rawEmail;
    const safePhone = looksMasked(rawPhone) ? "" : rawPhone;

    // Use the raw role SLUG (not the prettified display label) and resolve it to the matching
    // role option's value (roleOptionValue keys on role id or `slug::inst`), so the Role Select
    // preselects. Falls back to the slug if no option matches yet (options may still be loading).
    const roleSlug = String(row.roleSlug || row.raw?.role || "").toLowerCase();
    const matchedRole = (availableRoles || []).find(
      (r) => String(r.slug || r.role || "").toLowerCase() === roleSlug
    );
    const roleValue = matchedRole ? roleOptionValue(matchedRole) : (roleSlug || "");
    const deptId =
      row.departmentId ??
      row.raw?.departmentId ??
      row.raw?.department?.id ??
      "";

    setFormData({
      ...INITIAL_FORM_DATA,
      firstName: row.firstName || row.name?.split(" ")[0] || "",
      lastName: row.lastName || row.name?.split(" ").slice(1).join(" ") || "",
      email: safeEmail,
      phoneNumber: safePhone,
      role: roleValue,
      department: row.department && row.department !== "-" ? row.department : "",
      departmentId: deptId != null && deptId !== "" ? String(deptId) : "",
    });
    setCreateDialogOpen(true);
  };

  const openRoleSelectionDialog = () => {
    setEditingUser(null);
    setFormErrors({});
    setSelectedCreateRole("");
    setRoleSelectDialogOpen(true);
  };

  const handleContinueRoleSelection = () => {
    const resolved = parseRoleOptionValue(selectedCreateRole, availableRoles);
    const roleSlug = String(resolved?.slug || resolved?.role || selectedCreateRole || "").trim();
    if (!roleSlug) return;

    setRoleSelectDialogOpen(false);

    if (isStudentUserRole(roleSlug)) {
      openStudentDedicatedForm("create");
      return;
    }
    if (isTeacherUserRole(roleSlug)) {
      openTeacherDedicatedForm("create", null, roleSlug);
      return;
    }

    setFormData({
      ...INITIAL_FORM_DATA,
      role: roleOptionValue(resolved) || roleSlug,
    });
    setCreateDialogOpen(true);
  };

  return (
    <Box>
      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Box>
          <Typography variant="h5" fontWeight={600}>
            User Management
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage all users in the system
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.5 }}>
          <ActionButtons
            actions={[
              {
                type: "upload",
                label: "Import",
                permission: "user.import",
                onClick: () => setImportWizardOpen(true),
              },
              {
                type: "download",
                label: "Export",
                permission: "user.export",
                onClick: handleExport,
                disabled: displayUsers.length === 0,
              },
              {
                type: "add",
                label: "Add User",
                permission: "user.create",
                onClick: openRoleSelectionDialog,
              },
            ]}
          />
          <PermissionGate permission="user.export">
            <Typography variant="caption" color="text.secondary" sx={{ textAlign: "right" }}>
              Exported files have masked personal information. Contact support if you need the full personal information.
            </Typography>
          </PermissionGate>
        </Box>
      </Box>

      {(refreshingList || countsLoading) && (
        <LinearProgress sx={{ mb: 2 }} />
      )}

      {refreshingList && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Updating user list and counts…
        </Alert>
      )}

      {/* Stats */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[
          {
            label: "Total Users",
            value: userCounts.totalUsers || totalCount,
            color: "primary",
            icon: <People />,
          },
          {
            label: "Students",
            value: userCounts.students,
            color: "info",
            icon: <School />,
          },
          {
            label: "Teachers",
            value: userCounts.teachers || 0,
            color: "success",
            icon: <Person />,
          },
          {
            label: "HODs",
            value: userCounts.hod,
            color: "secondary",
            icon: <Person />,
          },
          {
            label: "Admins",
            value: userCounts.admins,
            color: "warning",
            icon: <AdminPanelSettings />,
          },
        ].map((stat, i) => (
          <Grid item xs={6} sm={2.4} key={i}>
            <StatsCard
              value={countsLoading ? "…" : stat.value}
              label={stat.label}
              icon={stat.icon}
              color={stat.color}
            />
          </Grid>
        ))}
      </Grid>

      <Card>
        <CardContent>
          <SearchBar
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search users..."
            sx={{ mb: 2 }}
          />

          <FilterTabs
            value={activeTab}
            onChange={handleTabChange}
            tabs={TAB_ROLES.map((role, i) => ({
              label: role,
              count:
                i === 0
                  ? (userCounts.totalUsers || totalCount)
                  : role === 'Student' ? userCounts.students
                    : role === 'Teacher' ? (userCounts.teachers || 0)
                      : role === 'HOD' ? userCounts.hod
                        : role === 'Admin' ? (userCounts.admins || users.filter((u) => matchRole(u.role, role)).length)
                          : users.filter((u) => matchRole(u.role, role)).length,
            }))}
            sx={{ mb: 2 }}
          />

          <DataTable
            rows={displayUsers}
            columns={columns}
            loading={loading || refreshingList}
            autoHeight
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}
            paginationMode="server"
            rowCount={rowCount}
            pageSizeOptions={PAGINATION_PAGE_SIZE_OPTIONS}
            actions={["view", "edit", "delete"]}
            onAction={(action, row) => {
              if (action === "view") {
                setViewingUser(row);
                setViewDialogOpen(true);
              } else if (action === "edit") {
                openUserEditFlow(row);
              } else if (action === "delete") {
                // Handle delete
                setUserToDelete(row);
                setDeleteDialogOpen(true);
              }
            }}
          />
        </CardContent>
      </Card>

      {/* Create/Edit Dialog */}
      <Dialog
        open={createDialogOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setCreateDialogOpen(false);
          setEditingUser(null);
          setFormErrors({});
          setFormData(INITIAL_FORM_DATA);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {editingUser ? "Edit User" : "Add New User"}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {editingUser &&
                canRevealRow(editingUser) &&
                (rowHasMaskedPii(editingUser) ||
                  looksMasked(formData.email) ||
                  looksMasked(formData.phoneNumber) ||
                  !formData.email ||
                  !formData.phoneNumber) && (
                  <Tooltip title="Reveal personal information">
                    <span>
                      <IconButton
                        onClick={() => handleRevealUserPii(editingUser, "edit")}
                        disabled={revealingUserPii}
                        color="primary"
                      >
                        {revealingUserPii ? <CircularProgress size={18} /> : <Visibility />}
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              <IconButton onClick={() => setCreateDialogOpen(false)}>
                <Close />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          {formErrors.submit && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {formErrors.submit}
            </Alert>
          )}
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="First Name *"
                value={formData.firstName}
                onChange={(e) => {
                  const value = e.target.value.replace(/\d/g, "").slice(0, 50);
                  setFormData({ ...formData, firstName: value });
                  if (formErrors.firstName) {
                    setFormErrors({ ...formErrors, firstName: "" });
                  }
                }}
                error={!!formErrors.firstName}
                helperText={formErrors.firstName}
                disabled={submitting}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Last Name *"
                value={formData.lastName}
                onChange={(e) => {
                  const value = e.target.value.replace(/\d/g, "").slice(0, 50);
                  setFormData({ ...formData, lastName: value });
                  if (formErrors.lastName) {
                    setFormErrors({ ...formErrors, lastName: "" });
                  }
                }}
                error={!!formErrors.lastName}
                helperText={formErrors.lastName}
                disabled={submitting}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            {editingUser &&
              canRevealRow(editingUser) &&
              (rowHasMaskedPii(editingUser) ||
                looksMasked(formData.email) ||
                looksMasked(formData.phoneNumber) ||
                !formData.email ||
                !formData.phoneNumber) && (
                <Grid item xs={12}>
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={revealingUserPii ? <CircularProgress size={16} /> : <Visibility />}
                    onClick={() => handleRevealUserPii(editingUser, "edit")}
                    disabled={revealingUserPii}
                    sx={{ textTransform: "none" }}
                  >
                    {revealingUserPii ? "Revealing personal information..." : "Reveal masked email & phone"}
                  </Button>
                </Grid>
              )}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={
                  editingUser
                    ? (formData.email ? "Email" : "Email (leave blank to keep unchanged)")
                    : "Email *"
                }
                value={formData.email}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormData({ ...formData, email: value });
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!value || !value.trim()) {
                    setFormErrors((prev) => ({ ...prev, email: "" }));
                  } else if (!emailRegex.test(value.trim())) {
                    setFormErrors((prev) => ({ ...prev, email: "Invalid email format" }));
                  } else {
                    setFormErrors((prev) => ({ ...prev, email: "" }));
                  }
                }}
                error={!!formErrors.email}
                helperText={
                  formErrors.email ||
                  (editingUser && !formData.email
                    ? "Masked contact info: click Reveal to view or edit, or leave blank to keep unchanged."
                    : undefined)
                }
                disabled={submitting}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl
                fullWidth
                variant="outlined"
                error={!!formErrors.phoneNumber}
                sx={{ width: '100%' }}
              >
                <InputLabel sx={{ top: '-5px' }} shrink htmlFor="phoneNumber">
                  {editingUser
                    ? (formData.phoneNumber ? "Phone" : "Phone (leave blank to keep unchanged)")
                    : "Phone *"}
                </InputLabel>
                <PhoneInput
                  country="in"
                  specialLabel=""
                  inputProps={{
                    id: 'phoneNumber',
                    name: 'phoneNumber',
                    'aria-label': 'Phone'
                  }}
                  value={formData.phoneNumber}
                  onChange={(phone) => {
                    setFormData({ ...formData, phoneNumber: phone });
                    // Real-time validation (same as Profile.js): show "Invalid phone number" as user types
                    if (!phone || String(phone).trim() === "") {
                      setFormErrors({ ...formErrors, phoneNumber: "" });
                    } else {
                      const digitsOnly = String(phone).replace(/\D/g, "");
                      setFormErrors({
                        ...formErrors,
                        phoneNumber: digitsOnly.length < 10 ? "Invalid phone number" : "",
                      });
                    }
                  }}
                  containerStyle={{
                    width: '100%',
                    marginTop: '4px',
                    marginBottom: '4px'
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "56px",
                    fontSize: "16px",
                    paddingLeft: "48px",
                    borderRadius: '4px',
                    boxSizing: 'border-box',
                    border: formErrors.phoneNumber
                      ? '1px solid #d32f2f'
                      : '1px solid rgba(0, 0, 0, 0.23)'
                  }}
                  disabled={submitting}
                />
                {formErrors.phoneNumber ? (
                  <FormHelperText>
                    {formErrors.phoneNumber}
                  </FormHelperText>
                ) : (
                  editingUser && !formData.phoneNumber && (
                    <FormHelperText>
                      Masked phone: click Reveal to view or edit, or leave blank to keep unchanged.
                    </FormHelperText>
                  )
                )}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth error={!!formErrors.role}>
                <InputLabel>Role *</InputLabel>
                <Select
                  value={formData.role}
                  label="Role *"
                  onChange={(e) => {
                    setFormData({ ...formData, role: e.target.value });
                    if (formErrors.role) {
                      setFormErrors({ ...formErrors, role: "" });
                    }
                  }}
                  disabled={submitting || rolesLoading}
                >
                  {rolesLoading ? (
                    <MenuItem disabled>Loading roles...</MenuItem>
                  ) : availableRoles.length > 0 ? (
                    availableRoles.map((role) => (
                      <MenuItem key={roleOptionValue(role)} value={roleOptionValue(role)}>
                        {formatRoleOptionLabel(role)}{" "}
                        <Chip
                          size="small"
                          label={role.roleScopeLabel || formatRoleScopeBadge(role)}
                          sx={{ ml: 0.5, height: 20, fontSize: "0.65rem" }}
                        />
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No roles available</MenuItem>
                  )}
                </Select>
                {formErrors.role && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                    {formErrors.role}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth error={!!formErrors.department}>
                <InputLabel>
                  {isRoleDepartmentOptional(formData.role, availableRoles)
                    ? "Department (Optional - Institute Wide)"
                    : "Department *"}
                </InputLabel>
                <Select
                  value={formData.departmentId || ""}
                  label={
                    isRoleDepartmentOptional(formData.role, availableRoles)
                      ? "Department (Optional - Institute Wide)"
                      : "Department *"
                  }
                  onChange={(e) => {
                    const deptId = e.target.value;
                    const dept = departments.find(
                      (d) => String(d.id) === String(deptId) || String(d._id) === String(deptId)
                    );
                    setFormData({
                      ...formData,
                      departmentId: deptId,
                      department: dept?.name || "",
                    });
                    if (formErrors.department) {
                      setFormErrors({ ...formErrors, department: "" });
                    }
                  }}
                  disabled={submitting || departmentsLoading}
                >
                  {isRoleDepartmentOptional(formData.role, availableRoles) && (
                    <MenuItem value="">
                      <em>None (Institute-wide)</em>
                    </MenuItem>
                  )}
                  {departmentsLoading ? (
                    <MenuItem disabled>Loading departments...</MenuItem>
                  ) : departments.length > 0 ? (
                    departments.map((dept) => (
                      <MenuItem key={dept._id || dept.id || dept} value={String(dept.id ?? dept._id ?? "")}>
                        {dept.name || dept}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No departments available</MenuItem>
                  )}
                </Select>
                {formErrors.department && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                    {formErrors.department}
                  </Typography>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCreateDialogOpen(false)} disabled={submitting}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleCreateUser}
            disabled={submitting}
            startIcon={submitting ? <CircularProgress size={18} color="inherit" /> : null}
          >
            {submitting ? (editingUser ? 'Updating...' : 'Creating...') : (editingUser ? 'Update User' : 'Create User')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Role selection dialog (entry point for Add User) */}
      <Dialog
        open={roleSelectDialogOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setRoleSelectDialogOpen(false);
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Select Role</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel>User Type *</InputLabel>
            <Select
              value={selectedCreateRole}
              label="User Type *"
              onChange={(e) => setSelectedCreateRole(e.target.value)}
              disabled={rolesLoading}
            >
              {rolesLoading ? (
                <MenuItem disabled>Loading roles...</MenuItem>
              ) : availableRoles.length > 0 ? (
                availableRoles.map((role) => (
                  <MenuItem key={roleOptionValue(role)} value={roleOptionValue(role)}>
                    {formatRoleOptionLabel(role)}{" "}
                    <Chip
                      size="small"
                      label={role.roleScopeLabel || formatRoleScopeBadge(role)}
                      sx={{ ml: 0.5, height: 20, fontSize: "0.65rem" }}
                    />
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No roles available</MenuItem>
              )}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRoleSelectDialogOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={!selectedCreateRole || rolesLoading}
            onClick={handleContinueRoleSelection}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* View User Dialog */}
      <Dialog
        open={viewDialogOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setViewDialogOpen(false);
          setViewingUser(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            User Details
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {viewingUser && canRevealRow(viewingUser) && rowHasMaskedPii(viewingUser) && (
                <Tooltip title="Reveal personal information">
                  <span>
                    <IconButton
                      onClick={() => handleRevealUserPii(viewingUser, "view")}
                      disabled={revealingUserPii}
                    >
                      {revealingUserPii ? <CircularProgress size={18} /> : <Visibility />}
                    </IconButton>
                  </span>
                </Tooltip>
              )}
              <IconButton onClick={() => setViewDialogOpen(false)}>
                <Close />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          {viewingUser && (
            <Box sx={{ pt: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
                <Avatar sx={{ width: 56, height: 56 }}>
                  {getAvatarInitial(viewingUser)}
                </Avatar>
                <Typography variant="h6">{viewingUser.name || "—"}</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" color="text.secondary">Email</Typography>
                  <Typography variant="body1">{viewingUser.email || "—"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" color="text.secondary">Phone</Typography>
                  <Typography variant="body1">{viewingUser.phone || "—"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" color="text.secondary">Role</Typography>
                  <Typography variant="body1">{viewingUser.role || "—"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" color="text.secondary">Department</Typography>
                  <Typography variant="body1">
                    {viewingUser.department ||
                      (isRoleDepartmentOptional(viewingUser.role, availableRoles)
                        ? "All Departments (Institute-wide)"
                        : "—")}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" color="text.secondary">Status</Typography>
                  <Typography variant="body1">{viewingUser.status || "—"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="caption" color="text.secondary">Created</Typography>
                  <Typography variant="body1">{viewingUser.createdAt || "—"}</Typography>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewDialogOpen(false)}>Close</Button>
          <PermissionGate permission="user.update">
            <Button
              variant="contained"
              onClick={() => {
                setViewDialogOpen(false);
                setViewingUser(null);
                if (viewingUser) {
                  openUserEditFlow(viewingUser);
                }
              }}
            >
              Edit User
            </Button>
          </PermissionGate>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          if (!deleting) {
            setDeleteDialogOpen(false);
            setUserToDelete(null);
          }
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the user "{userToDelete?.name}"?
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={deleting}>
            Cancel
          </Button>
          <PermissionGate permission="user.delete">
            <Button
              variant="contained"
              color="error"
              onClick={handleDeleteUser}
              disabled={deleting}
              startIcon={deleting ? <CircularProgress size={18} color="inherit" /> : null}
            >
              {deleting ? "Deleting..." : "Delete"}
            </Button>
          </PermissionGate>
        </DialogActions>
      </Dialog>

      {/* Import Wizard */}
      <DataImportWizard
        open={importWizardOpen}
        onClose={() => setImportWizardOpen(false)}
        entityType="users"
        onImportComplete={async () => {
          try {
            await refreshUsersAndCounts();
          } catch (err) {
            console.error("Error refreshing users after wizard import:", err);
          }
        }}
      />

      {/* Import Dialog */}
      <ImportDialog
        open={importDialogOpen}
        onClose={() => {
          setImportDialogOpen(false);
          setPreviewData([]);
        }}
        onImport={handleImport}
        title="Import Users"
        templateUrl="/templates/users.xlsx"
        previewColumns={previewColumns}
        validateRow={validateRow}
      />

      {/* Mount existing Teacher popup logic without page routing */}
      {teacherPopupState.open && (
        <Box sx={{ display: "none" }}>
          <HODTeachers
            openFromParent={
              teacherPopupState.open && teacherPopupState.mode === "create"
            }
            openEditFromParent={
              teacherPopupState.open && teacherPopupState.mode === "edit"
            }
            parentRole={teacherPopupState.role}
            parentEditData={teacherPopupState.editData}
            parentPrefillLoading={teacherPopupState.prefillLoading}
            onParentClose={async () => {
              setTeacherPopupState({
                open: false,
                role: "teacher",
                mode: "create",
                editData: null,
                prefillLoading: false,
              });
              await refreshUsersAndCounts();
            }}
          />
        </Box>
      )}

      {/* Mount existing Student popup logic without page routing */}
      {studentPopupState.open && (
        <Box sx={{ display: "none" }}>
          <TeacherStudents
            openFromParent={
              studentPopupState.open && studentPopupState.mode === "create"
            }
            openEditFromParent={
              studentPopupState.open && studentPopupState.mode === "edit"
            }
            parentEditData={studentPopupState.editData}
            parentPrefillLoading={studentPopupState.prefillLoading}
            onParentClose={async () => {
              setStudentPopupState({
                open: false,
                mode: "create",
                editData: null,
                prefillLoading: false,
              });
              await refreshUsersAndCounts();
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default Users;
